import { Epic, ofType } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { actions } from '.';
import { addErrorNotice, callApi, catchWithAuthErrors } from 'Data/Helpers/rxjsHelpers';
import webApi from 'Lib/WebApi';
import { of } from 'rxjs';

export const init: Epic = (action$) =>
  action$.pipe(
    ofType(actions.init.toString()),
    mergeMap(({ payload: { workOrderId = null } }) =>
      callApi(webApi.ags.exports.query.get({ workOrderId })).pipe(
        mergeMap((response) => of(actions.initResolve(response.Body))),
        catchWithAuthErrors((err: any) =>
          of(actions.initReject(), addErrorNotice('Failed to initialise Work Order.', err))
        )
      )
    )
  );

export const runNewExport: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.runNewExport.toString()),
    withLatestFrom(state$),
    mergeMap(([action, { agsWorkOrderExport: { workOrderId = null } }]) =>
      callApi(webApi.ags.exports.create.post({ Body: { WorkOrderId: workOrderId } })).pipe(
        mergeMap((response) => of(actions.runNewExportResolve(response.Body))),
        catchWithAuthErrors((err?: any) =>
          of(addErrorNotice('Failed to run new AGS Work Order Export.', err), actions.runNewExportReject())
        )
      )
    )
  );
